import React from 'react'
import { TextField, Box } from '@mui/material'
import { Controller } from 'react-hook-form'

interface EditVehicleFormProps {
  errors: any
  control: any
}

export const EditVehicleForm: React.FC<EditVehicleFormProps> = ({ errors, control }) => {
  return (
    <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Controller
        name="exteriorColor"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label="Color"
            variant="outlined"
            fullWidth
            error={!!errors.exteriorColor}
            helperText={errors.exteriorColor?.message}
          />
        )}
      />

      <Controller
        name="make"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label="Make"
            variant="outlined"
            fullWidth
            error={!!errors.make}
            helperText={errors.make?.message}
          />
        )}
      />

      <Controller
        name="model"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label="Model"
            variant="outlined"
            fullWidth
            error={!!errors.model}
            helperText={errors.model?.message}
          />
        )}
      />

      <Controller
        name="financier"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label="Financier"
            variant="outlined"
            fullWidth
            error={!!errors.financier}
            helperText={errors.financier?.message}
          />
        )}
      />
    </Box>
  )
}
